import React from 'react';

export const PageBreakElement = (props) => {
  const { attributes, children, nodeProps } = props;
  return (
    <div
      {...attributes}
      className="slate-page-break"
      style={{
        pageBreakAfter: 'always',
        pageBreakInside: 'avoid',
      }}
      contentEditable={false}
      {...nodeProps}
    >
      {children}
    </div>
  );
};
